import { HubConnection, HubConnectionBuilder, IHttpConnectionOptions } from "@microsoft/signalr";
import * as Utils from "@shoothill/core";

export class SignalRService {
    private static instance: SignalRService;
    public hubConnection: HubConnection;

    // Make the constructor private to prevent external instantiation.
    private constructor(private hubUrl: string) {
        this.hubConnection = new HubConnectionBuilder()
            .withUrl(this.hubUrl, {
                accessTokenFactory: async () => await this.getAccessToken(),
            })
            .withAutomaticReconnect()
            .build();
        this.initializeSignalR();
    }

    public static getInstance(hubUrl: string): SignalRService {
        if (!SignalRService.instance) {
            SignalRService.instance = new SignalRService(hubUrl);
        }
        return SignalRService.instance;
    }

    private async initializeSignalR() {
        await this.hubConnection
            .start()
            .then(() => {
                console.log("SignalR Connected");
            })
            .catch((err) => {
                console.error("SignalR Connection Error: ", err);
            });
    }

    private async getAccessToken(): Promise<string> {
        return await Utils.getJWT();
    }

    public async sendMessage(method: string, message: any): Promise<void> {
        if (!this.hubConnection) {
            throw new Error("No connection to the server.");
        }
        await this.hubConnection.send(method, message);
    }

    public async stopConnection(): Promise<void> {
        if (!this.hubConnection) {
            throw new Error("No connection to stop.");
        }
        await this.hubConnection.stop();
        console.log("Connection stopped");
    }

    public static async stop() {
        if (SignalRService.instance && SignalRService.instance.hubConnection) {
            await SignalRService.instance.stopConnection();
        } else {
            console.log("No connection to stop");
        }
    }
}
